export enum UserRole {
  ADMIN = 'fly_developer_admin',
  DEVELOPER = 'fly_developer',
}

export const UserStatus = {
  ACCEPTED: 'ACCEPTED',
  EXPIRED: 'EXPIRED',
  REVOKED: 'REVOKED',
  INVITED: 'INVITED',
  CANCELLED: 'CANCELLED',
} as const;
export type UserStatus = (typeof UserStatus)[keyof typeof UserStatus];
